import { GetterTree } from 'vuex';

import { BreadcrumbsStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<BreadcrumbsStateI, RootStateI> = {
};
